import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=3e450638&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=3e450638&prod&scoped=true&lang=css&"
import style1 from "./NotificationHandler.vue?vue&type=style&index=1&id=3e450638&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e450638",
  null
  
)

export default component.exports